import { Group, PermissionsGroup } from "@robe/core-types/group";
import { handleXcoreError, SaveGroupError } from "@robe/core-api/errors";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export interface SaveGroupResponse {
  id: string;
  name: string;
  permissions: PermissionsGroup[];
}

/**
 * @throws {SaveGroupError}
 */
export const saveGroup =
  (method: "PUT" | "POST") =>
    (
      group: Group | (Partial<Group> & Omit<Group, "id">),
      permissions: PermissionsGroup[],
      core: XcoreCore
    ): BaseApiRequest<SaveGroupResponse> =>
      core
        .fetch("/api/groups", {
          method,
          body: JSON.stringify({ ...group, permissions }),
        })
        .then((res, url) => (res.ok ? res.json() : handleSaveGroupError(url, res)));

/**
 * @throws {SaveGroupError}
 */
export const insertGroup = saveGroup("POST");

const handleSaveGroupError = handleXcoreError((...args) => new SaveGroupError(...args));
